// src/pages/ClientHomePage.tsx
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { brandColors } from "../App";
import { RootState } from "../store";

// Images
import bgImage from "../asset/background.png";
import baklavaImg from "../asset/baklava.png";
import dryImg from "../asset/dryfruits.png";
import heroImage from "../asset/hero-food.png";
import nutsImg from "../asset/nuts.png";
import olivesImg from "../asset/olives.png";
import turkishImg from "../asset/turkish.png";
import italianImg from "../asset/italian.png";

const categories = [
  { title: "Nuts", img: nutsImg },
  { title: "Dry Fruits", img: dryImg },
  { title: "Baklava", img: baklavaImg },
  { title: "Olives", img: olivesImg },
  { title: "Turkish Delights", img: turkishImg },
  { title: "Italian", img: italianImg },
];
const orders = [
  {
    title: "Order 1",
    img: nutsImg,
    items: [1, 2, 3],
    location: "Location 1",
    status: "PENDING",
  },
  {
    title: "Order 2",
    img: dryImg,
    items: [1, 2, 3],
    location: "Location 1",
    status: "PENDING",
  },
  {
    title: "Order 3",
    items: [1, 2, 3],
    location: "Location 1",
    status: "PENDING",
  },
  {
    title: "Order 4",
    items: [1, 2, 3],
    location: "Location 1",
    status: "PENDING",
  },
  {
    title: "Order 5",
    items: [1, 2, 3],
    location: "Location 1",
    status: "PENDING",
  },
];

const ClientHomePage = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const navigate = useNavigate();

  return (
    // <Box sx={{ px: { xs: 2, md: 5 }, py: 4, background: "#f8f9f6" }}>
    <Box
      sx={{
        position: "relative",
        height: "82vh",
        overflow: "scroll",
        scrollbarWidth: "none",
        px: { xs: 2, md: 5 },
        py: 4,
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        // "&::before": {
        //   content: '""',
        //   position: "absolute",
        //   inset: 0,
        //   backgroundColor: "rgba(255,255,255,0.6)",
        // },
      }}
    >
      {/* HERO SECTION */}
      <Paper
        elevation={3}
        sx={{
          borderRadius: 4,
          overflow: "hidden",
          mb: 5,
          background: brandColors.primary,
          color: "white",
        }}
      >
        <Grid container alignItems="center">
          <Grid size={{ xs: 12, md: 6 }} sx={{ p: 4 }}>
            <Typography variant="h4" sx={{ fontWeight: 600 }}>
              Welcome Back,
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
              {user?.first_name || "Client"}
            </Typography>

            <Typography variant="body1" sx={{ mb: 3, opacity: 0.9 }}>
              Premium Mediterranean Nuts, Dry Fruits & Delicacies. Manage your
              wholesale orders with ease.
            </Typography>

            <Stack direction="row" spacing={2}>
              {/* <Button
                variant="outlined"
                sx={{
                  background: brandColors.secondary,
                  px: 3,
                  borderRadius: 3,
                }}
                onClick={() => navigate("/clientInventory")}
              >
              </Button> */}

              <Button
                variant="outlined"
                sx={{
                  borderColor: "white",
                  color: "white",
                  px: 3,
                  borderRadius: 3,
                  "&:hover": {
                    background: "white",
                    color: brandColors.primary,
                  },
                }}
                onClick={() => navigate("/clientInventory")}
              >
                Browse Products
              </Button>
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              component="img"
              src={heroImage}
              alt="Kalamata Products"
              sx={{
                width: "100%",
                height: { xs: 250, md: 380 },
                objectFit: "cover",
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* CATEGORY SECTION */}
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, mb: 3, color: "#26573d" }}
      >
        Product Categories
      </Typography>

      <Grid container spacing={3}>
        {categories.map((cat, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
            <Card
              sx={{
                borderRadius: 4,
                transition: "0.3s",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: 6,
                },
                cursor: "pointer",
              }}
              onClick={() =>
                navigate("/clientInventory", {
                  state: {
                    category: cat.title,
                  },
                })
              }
            >
              <CardMedia
                component="img"
                height="180"
                image={cat.img}
                alt={cat.title}
              />
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: brandColors.primary }}
                >
                  {cat.title}
                </Typography>
                {/* <Button
                  size="small"
                  sx={{ mt: 1 }}
                  onClick={() => navigate("/clientInventory",{
                    state: {
                      category: cat.title
                    }
                  })}
                >
                  Browse
                </Button> */}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 6 }}>
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, mb: 3, color: brandColors.primary }}
        ></Typography>

        <Grid container spacing={3}>
          {/* {[
            { label: "Total Orders", value: "128" },
            { label: "Pending Requests", value: "6" },
            { label: "Monthly Spend", value: "$12,540" },
          ].map((item, i) => (
            <Grid size={{ xs: 12, md: 4 }} key={i}>
              <Paper
                elevation={2}
                sx={{
                  p: 3,
                  borderRadius: 4,
                  textAlign: "center",
                  background: "rgba(255, 255, 255, 0.1)",
                  backdropFilter: "blur(10px)",
                }}
              >
                <Typography variant="h6" sx={{ color: "gray" }}>
                  {item.label}
                </Typography>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 700, color: brandColors.secondary }}
                >
                  {item.value}
                </Typography>
              </Paper>
            </Grid>
          ))} */}
        </Grid>
        {/* <Paper
          elevation={0}
          sx={{
            p: 3,
            borderRadius: 3,
            background: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
          }}
        >
          <Typography variant="h6" mb={2}>
            Recent Orders
          </Typography>

          {orders.map((order, index) => (
            <Box key={index} mb={2}>
              <Typography fontWeight={600}>Order {order.title}</Typography>
              <Typography variant="body2">
                {order.items} — {order.location}
              </Typography>
              <Chip
                label={order.status}
                size="small"
                sx={{
                  mt: 1,
                  // ...getStatusStyles(order.status),
                }}
              />
              <Divider sx={{ mt: 2 }} />
            </Box>
          ))}
        </Paper> */}
      </Box>
    </Box>
  );
};

export default ClientHomePage;
